export const rowTypeAttr = 'k-parent-node';
export const colgroupAttr = 'k-colgroup-data';
export const resizableAttr = 'k-resizable-node';
export const resizableWrap = 'k-editor-resize-wrap-element';
export const resizeHandle = 'k-editor-resize-handle';
export const dataResizeDirTable = 'data-dir-table-resize';
export const dataResizeDirImage = 'data-dir-image-resize';
